import {
  GET_MEETING_DETAILS_INIT,
  GET_MEETING_DETAILS_SUCCESS,
  GET_MEETING_DETAILS_FAILED,
  UPDATE_STATUS_ATTENDEE_INIT,
  UPDATE_STATUS_ATTENDEE_SUCCESS,
  UPDATE_STATUS_ATTENDEE_FAILED,
  UPDATE_GOOGLE_CALENDAR_MEETING_INIT,
  UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS,
  UPDATE_GOOGLE_CALENDAR_MEETING_FAILED,
  UPDATE_OUTLOOK_CALENDAR_MEETING_INIT,
  UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS,
  UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED,
  GET_MONTHLY_MEETING_INIT,
  GET_MONTHLY_MEETING_SUCCESS,
  GET_MONTHLY_MEETING_FAILED
} from "./constants";
const initialState = {
  loading: false,
  statusLoading: false,
  getMeeting: {},
  meetingData: [],
};

export default function meetingDetails(state = initialState, action) {
  switch (action.type) {
    case GET_MONTHLY_MEETING_INIT:
      return { ...state, loading: true };
    case GET_MONTHLY_MEETING_SUCCESS:
      console.log("action payload ", action.payload);
      return { ...state, loading: false, meetingData: action.payload };
    case GET_MONTHLY_MEETING_FAILED:
      return { ...state, loading: false };
    case GET_MEETING_DETAILS_INIT:
      return { ...state, loading: true };
    case GET_MEETING_DETAILS_SUCCESS:
      return { ...state, loading: false, getMeeting: action.payload };
    case GET_MEETING_DETAILS_FAILED:
      return { ...state, loading: false };
    case UPDATE_STATUS_ATTENDEE_INIT:
      return { ...state, statusLoading: true };
    case UPDATE_STATUS_ATTENDEE_SUCCESS:
      const appointmentAttendee = action.payload;
      var meetingsAttendees = state.getMeeting?.appointmentAttendees?.map(
        (item) => {
          if (item.userAttendeeId === appointmentAttendee.userAttendeeId) {
            item.status = appointmentAttendee.status;
          }
          return item;
        }
      );
      return {
        ...state,
        getMeeting: {
          ...state.getMeeting,
          appointmentAttendees: meetingsAttendees,
        },
        statusLoading: false,
      };
    case UPDATE_STATUS_ATTENDEE_FAILED:
      return { ...state, statusLoading: false };
    case UPDATE_GOOGLE_CALENDAR_MEETING_INIT:
      return { ...state, loading: true };
    case UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_GOOGLE_CALENDAR_MEETING_FAILED:
      return { ...state, loading: false };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_INIT:
      return { ...state, loading: true };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
